import { render, staticRenderFns } from "./CampaignContactsModal.vue?vue&type=template&id=39eb43f3&"
import script from "./CampaignContactsModal.vue?vue&type=script&lang=ts&"
export * from "./CampaignContactsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39eb43f3')) {
      api.createRecord('39eb43f3', component.options)
    } else {
      api.reload('39eb43f3', component.options)
    }
    module.hot.accept("./CampaignContactsModal.vue?vue&type=template&id=39eb43f3&", function () {
      api.rerender('39eb43f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/CampaignContactsModal.vue"
export default component.exports